import { render, staticRenderFns } from "./VehicleSelectionForm.vue?vue&type=template&id=2292e813&"
import script from "./VehicleSelectionForm.vue?vue&type=script&lang=js&"
export * from "./VehicleSelectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports